(() => {
  const frameId = 'BIS_frame';
  const styleId = 'LumanoBackInStockTheme';
  const fontLinkId = 'LumanoBackInStockFont';

  const modalCss = `
    :root {
      color-scheme: dark;
      font-size: 16px;
    }

    *,
    *::before,
    *::after {
      box-sizing: border-box;
      border-radius: 0 !important;
    }

    html,
    body {
      width: 100%;
      min-height: 100%;
      margin: 0;
      background: transparent !important;
      color: #f2f0eb !important;
      font-family: "Switzer", "Helvetica Neue", Helvetica, Arial, sans-serif !important;
    }

    body.bis-popover-active {
      background: rgba(0, 0, 0, 0.56) !important;
    }

    #BISModal,
    #BISModal .modal {
      position: fixed;
      inset: 0;
      width: 100%;
      height: 100%;
    }

    #BISModal .modal {
      display: grid !important;
      place-items: center;
      overflow: auto;
      padding: clamp(1rem, 3vw, 3rem);
    }

    #BISModal .modal-dialog {
      width: min(100%, 36rem);
      max-width: none;
      margin: 0 !important;
    }

    #BISModal .modal-content {
      overflow: hidden;
      border: 1px solid #545454 !important;
      background: #000 !important;
      color: #f2f0eb !important;
      box-shadow: 0 2rem 6rem rgba(0, 0, 0, 0.72) !important;
    }

    #BISModal .modal-header {
      display: grid;
      grid-template-columns: minmax(0, 1fr) auto;
      align-items: center;
      gap: 1.5rem;
      min-height: 4.75rem;
      padding: 1.25rem 1.5rem;
      border: 0 !important;
      border-bottom: 1px solid #323232 !important;
      background: #000 !important;
    }

    #BISModal .modal-title {
      margin: 0;
      color: #f2f0eb !important;
      font-size: 0.95rem !important;
      font-weight: 600;
      letter-spacing: 0.12em;
      line-height: 1.35;
      text-transform: uppercase;
    }

    #BISModal .close {
      display: grid;
      width: 2.75rem;
      height: 2.75rem;
      place-items: center;
      margin: -0.5rem -0.5rem -0.5rem 0;
      border: 1px solid #323232 !important;
      background: #000 !important;
      color: #aaa69d !important;
      font-size: 1.1rem;
      line-height: 1;
      cursor: pointer;
      transition:
        border-color 160ms cubic-bezier(0.23, 1, 0.32, 1),
        background 160ms cubic-bezier(0.23, 1, 0.32, 1),
        color 160ms cubic-bezier(0.23, 1, 0.32, 1);
    }

    #BISModal .close:hover,
    #BISModal .close:focus-visible {
      border-color: #f2f0eb !important;
      background: #f2f0eb !important;
      color: #000 !important;
    }

    #BISModal .modal-body {
      padding: 1.5rem !important;
      background: #000 !important;
      color: #aaa69d !important;
    }

    #BISModal .modal-body > p:first-child {
      margin: 0 0 1.25rem;
      color: #aaa69d !important;
      font-size: 0.9rem;
      line-height: 1.5;
    }

    #BISModal .product-name {
      margin: 0 0 1.5rem;
      color: #f2f0eb !important;
      font-size: 1.25rem !important;
      font-weight: 400;
      letter-spacing: 0.035em;
      line-height: 1.3;
    }

    #BISModal .form-group {
      margin-bottom: 1rem !important;
    }

    #BISModal .form-control {
      width: 100%;
      min-height: 3.25rem;
      padding: 0.85rem 1rem !important;
      border: 1px solid #545454 !important;
      background: #000 !important;
      color: #f2f0eb !important;
      box-shadow: none !important;
      font: inherit;
      font-size: 0.95rem !important;
      line-height: 1.3;
      outline: none;
    }

    #BISModal .form-control::placeholder {
      color: #85817a !important;
      opacity: 1;
    }

    #BISModal .form-control:focus {
      border-color: #f2f0eb !important;
      box-shadow: 0 0 0 1px #f2f0eb !important;
    }

    #BISModal #submit-btn {
      display: inline-flex;
      width: 100%;
      min-height: 3.25rem;
      align-items: center;
      justify-content: center;
      padding: 0.85rem 1.25rem !important;
      border: 1px solid #f2f0eb !important;
      background: #f2f0eb !important;
      color: #000 !important;
      box-shadow: none !important;
      font-family: inherit;
      font-size: 0.78rem !important;
      font-weight: 650;
      letter-spacing: 0.12em;
      line-height: 1.2;
      text-transform: uppercase;
      cursor: pointer;
      transition:
        background 160ms cubic-bezier(0.23, 1, 0.32, 1),
        color 160ms cubic-bezier(0.23, 1, 0.32, 1);
    }

    #BISModal #submit-btn:hover,
    #BISModal #submit-btn:focus-visible {
      background: #000 !important;
      color: #f2f0eb !important;
    }

    #BISModal .small-print {
      margin: 1rem 0 0;
      color: #85817a !important;
      font-size: 0.72rem !important;
      line-height: 1.45;
    }

    #BISModal a {
      color: #dedad3 !important;
      text-decoration-color: #545454;
      text-underline-offset: 0.22em;
    }

    #BISModal .alert {
      border: 1px solid #545454 !important;
      background: #000 !important;
      color: #f2f0eb !important;
    }

    @media (max-width: 40rem) {
      #BISModal .modal {
        align-items: end;
        padding: 0.75rem;
      }

      #BISModal .modal-dialog {
        width: 100%;
      }

      #BISModal .modal-header,
      #BISModal .modal-body {
        padding-right: 1.25rem !important;
        padding-left: 1.25rem !important;
      }
    }

    @media (prefers-reduced-motion: reduce) {
      *,
      *::before,
      *::after {
        transition-duration: 0.01ms !important;
      }
    }
  `;

  const installTheme = (frame, forceObserver = false) => {
    try {
      const frameDocument = frame.contentDocument;
      if (!frameDocument?.head || !frameDocument.documentElement) return;

      if (!frameDocument.getElementById(fontLinkId)) {
        // Switzer is declared inline in the layout; reuse its preloaded file.
        const parentFontPreload = document.querySelector('link[rel="preload"][href*="Switzer-Variable"]');
        if (parentFontPreload) {
          const fontStyle = frameDocument.createElement('style');
          fontStyle.id = fontLinkId;
          fontStyle.textContent = `@font-face { font-family: "Switzer"; src: url("${parentFontPreload.href}") format("woff2"); font-weight: 100 900; font-style: normal; font-display: swap; }`;
          frameDocument.head.appendChild(fontStyle);
        }
      }

      if (!frameDocument.getElementById(styleId)) {
        const style = frameDocument.createElement('style');
        style.id = styleId;
        style.textContent = modalCss;
        frameDocument.head.appendChild(style);
      }

      if (forceObserver || frame.lumanoObservedDocument !== frameDocument) {
        frame.lumanoModalObserver?.disconnect();
        frame.lumanoObservedDocument = frameDocument;
        frame.lumanoModalObserver = new MutationObserver(() => installTheme(frame));
        frame.lumanoModalObserver.observe(frameDocument.documentElement, {
          childList: true,
          subtree: true,
        });
      }
    } catch (error) {
      // The app currently uses a same-origin about:blank iframe. If that changes,
      // leave its own presentation intact rather than interrupting the modal.
    }
  };

  const connectFrame = () => {
    const frame = document.getElementById(frameId);
    if (!frame) return;

    if (!frame.lumanoThemeLoadHandler) {
      frame.lumanoThemeLoadHandler = () => installTheme(frame, true);
      frame.addEventListener('load', frame.lumanoThemeLoadHandler);
    }

    installTheme(frame);
  };

  const start = () => {
    connectFrame();
    new MutationObserver(connectFrame).observe(document.documentElement, {
      attributes: true,
      attributeFilter: ['class', 'src', 'style'],
      childList: true,
      subtree: true,
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();
